<h1 mat-dialog-title class="p-2 text-center" i18n>Recherche de comptes</h1>
<div mat-dialog-content class="p-3 overflow-hidden">
    <div class="container-fluid d-flex flex-column max-height-600">

        <div class="row align-items-center flex-60-px">
            <div class="col-6 text-center">
                <h5 i18n>Comptes déjà configurés</h5>
            </div>
            <div class="col mt-3">

                <mat-form-field class="w-100">
                    <input matInput [(ngModel)]="searchText" i18n-placeholder placeholder="Code ou Nom de client" (keyup.enter)="searchNewClient()">
                </mat-form-field>
            </div>
            <div class="col-auto">

                <button appPreventDoubleClick class="" color="primary" mat-mini-fab (throttledClick)="searchNewClient()">
                    <mat-icon class="material-symbols-outlined"> search </mat-icon>
                </button>

            </div>
        </div>

        <div class="row align-items-center max-height-400">
            <div class="col-6 h-100 overflow-y-only">

                @if (alreadyAssignedList.length) {
                <div class="">
                    @for (c of alreadyAssignedList; track c.Code;let i = $index) {
                    <div>
                        <div class="row" [ngClass]="{'selected' : isHover === i}" (mouseenter)="isHover = i">

                            <div class="col">{{c.Name}} - {{c.City}} ({{c.ElimsClientCode}})</div>
                            <div class="col-auto">
                                <button class="col-auto small-icon-button" mat-icon-button (click)="deleteClient(c)">
                                    <mat-icon color="warn" class="material-symbols-outlined">delete</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                    }
                </div>
                }
            </div>

            <div class="col-6 h-100 overflow-y-only">
                @if (AvailableClientList.length >= 1) {
                <mat-selection-list #allSelected class="" (selectionChange)="setSelectedClients($event)" multiple>
                    <h3 matSubheader class="row align-items-center me-2">
                        <div class="col text-end align-bottom fst-italic" i18n>Tous</div>
                        <div class="col-auto pe-0">
                            <mat-checkbox (change)=" $event.checked ? selectAll() : unselectAll()">
                            </mat-checkbox>
                        </div>
                    </h3>
                    @for (c of AvailableClientList; track c.Code) {

                    <mat-list-option class="col-12 justify-content-center align-items-center" [value]="c">
                        <mat-icon class="material-symbols-outlined" mat-list-icon>face</mat-icon>
                        {{c.Name}} - {{c.City}} ({{c.ElimsClientCode}})
                        <mat-divider></mat-divider>
                    </mat-list-option>
                    }
                </mat-selection-list>
                }
            </div>
        </div>

        <div class="row mt-3 g-0 flex-60-px">
            <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()" i18n>
                Annuler
            </button>
            <button appPreventDoubleClick class="col ms-1" color="accent" mat-raised-button (throttledClick)="onConfirm()" i18n>
                Enregistrer
            </button>
        </div>
    </div>
</div>